import axios from 'axios';
import config from '../Config';

const API_URL = config.API_URL;
const axiosClient = axios.create();
axiosClient.defaults.baseURL = config.API_URL;

const register = (username, email, password) => {
  return axios.post(API_URL + 'signup', {
    username,
    email,
    password,
  });
};

const login = (email, password) => {
  return axiosClient
    .post(API_URL + '/get-token/', {
      email,
      password,
    })
    .then(response => {
      if (response.data.success) {
        localStorage.setItem('auth_token', response.data.data.access);
        localStorage.setItem('refresh_token', response.data.data.refresh);
        localStorage.setItem('user', JSON.stringify(response.data.data.userData));
      }

      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('refresh_token');
 // localStorage.removeItem('user');
};

const authService = {
  register,
  login,
  logout,
};

export default authService;
